<template>
  <div id="app" class="">
    <Header/>
    <Hello/>
    <Education/>
    <Experience/>
    <Endorsement/>
    <Skills/>
    <Projects/>
    <Contact/>
    <Chatbot/>
  </div>
</template>

<script>
import Header from './components/Header'
import Hello from './components/Hello'
import Education from './components/Education'
import Experience from './components/Experience'
import Endorsement from './components/Endorsement'
import Skills from './components/Skills'
import Projects from './components/Projects'
import Contact from './components/Contact'
import Chatbot from './components/Chatbot'

import axios from 'axios'

export default {
  components: { Header, Hello, Education, Experience, Skills, Projects, Contact, Endorsement, Chatbot},
  name: 'App',
  created(){
    this.$getLocation({ enableHighAccuracy: true })
    .then(coordinates => {
      axios.post('https://portfolio-debarshi-api.herokuapp.com/api/v1/location', {
        lat: coordinates.lat,
        lng: coordinates.lng,
      })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(`Error: ${error}`);
      });
    }).catch(err => {
      axios.post('https://portfolio-debarshi-api.herokuapp.com/api/v1/location').then(response => {
        console.log(response);
      })
      console.log(`Error: ${err}`)
    });
  }
}
</script>


